// extracted by mini-css-extract-plugin
export default {"root":"Option_root__PmKUF","remove":"Option_remove__V80cs","body":"Option_body__rdELe","clickable":"Option_clickable__+nfgW"};